var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"preview-overlay",on:{"click":_vm.close}},[_c('img',{staticClass:"preview-image",attrs:{"src":_vm.src}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }